module.exports = __webpack_public_path__ + "img/App_Store_Badge.d88d7d95.svg";